



















import Vue from 'vue'
import { gpsStates, networkStates, batteryStates } from '@/components/InstallDevices/constants'
import Loader from '@/components/Global/Loader.vue'
import { portalState } from '@/state'
import { apiLiveUpdatesEndpoint } from '@/api'

const { GPS_STRONG_CONNECTION, GPS_MEDIUM_CONNECTION, GPS_WEAK_CONNECTION } = gpsStates
const { NETWORK_CONNECTED, NETWORK_DISCONNECTED } = networkStates
const { BATTERY_CONNECTED, BATTERY_DISCONNECTED } = batteryStates

export default Vue.extend({
  name: 'InstallImeiStatus',
  components: { Loader },
  props: {
    imei: String
  },
  computed: {
    computedBatteryState () {
      switch (this.batteryState) {
        case BATTERY_CONNECTED:
          return { icon: 'far fa-battery-bolt', color: 'success' }
        default:
          return { icon: 'far fa-battery-slash', color: 'text--secondary' }
      }
    },
    computedNetworkState () {
      switch (this.networkState) {
        case NETWORK_CONNECTED:
          return { icon: 'fas fa-circle', color: 'success' }
        default:
          return { icon: 'fas fa-circle', color: 'text--secondary' }
      }
    },
    computedGPSState () {
      switch (this.gpsState) {
        case GPS_STRONG_CONNECTION:
          return { icon: 'far fa-satellite', color: 'success' }
        case GPS_MEDIUM_CONNECTION:
          return { icon: 'far fa-satellite', color: 'text--secondary' }
        default:
          return { icon: 'far fa-satellite', color: 'text--secondary' }
      }
    }
  },
  data () {
    return {
      eventStream: null,
      eventState: 'connecting',
      networkState: NETWORK_DISCONNECTED,
      gpsState: GPS_WEAK_CONNECTION,
      batteryState: BATTERY_DISCONNECTED
    }
  },
  methods: {
    connectToStream () {
      if (!this.imei) return
      this.eventStream = new EventSource(`${apiLiveUpdatesEndpoint}/real-time/status?imei=${this.imei}&bearer=${portalState.bearer}`)
      this.eventStream.onopen = () => { this.eventState = 'connected' }
      this.eventStream.onerror = () => {
        console.log('Node live updates service has an error or you are timed out and attempting to reconnect')
        this.eventState = 'connecting'
      }
      this.eventStream.onmessage = (m: any) => {
        this.eventState = 'live'
        const statusArray = JSON.parse(m.data)
        const batteryConnected: boolean = statusArray[6]
        const satellites: number = statusArray[7]

        this.networkState = NETWORK_CONNECTED

        if (batteryConnected) {
          this.batteryState = BATTERY_CONNECTED
        } else {
          this.batteryState = BATTERY_DISCONNECTED
        }

        if (satellites > 6) {
          this.gpsState = GPS_STRONG_CONNECTION
        } else if (satellites > 1) {
          this.gpsState = GPS_MEDIUM_CONNECTION
        } else {
          this.gpsState = GPS_WEAK_CONNECTION
        }
      }
    },
    resetState () {
      this.eventStream = null
      this.eventState = 'connecting'
      this.networkState = NETWORK_DISCONNECTED
      this.gpsState = GPS_WEAK_CONNECTION
      this.batteryState = BATTERY_DISCONNECTED
    }
  },
  mounted () {
    this.connectToStream()
  },
  watch: {
    imei () {
      this.resetState()
      this.connectToStream()
    }
  },
  beforeDestroy () {
    this.eventStream.close()
  }
})
